import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import './reset.css'
import Header from '../components/Header'
import Footer from '../components/Footer'

import './home.css'
import './hero.css'
import './docs.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Johnny Metrics :: Crypto portfolio tracker and reporting"
    />
    <Header />
    <div>
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js